import { GetProducts } from '@/connection/content/products';
import { ContentReducerCreator } from '../types';

const loadProductsReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetProducts(channel);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.products = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadProductsReducer;
